import careerSubscribe			from './modules/career-subscribe/career-subscribe';
import app           			from '../shared/shared';

/**
 * register the modules that should be
 * bootstrapped.
 */

app.registerModules([
	careerSubscribe
]);
